var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawnAccents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4421 21.7603C14.5205 21.0183 17.485 21.0669 20.6074 20.978C21.2172 20.9607 21.7242 21.4301 21.7426 22.0259C21.7609 22.6221 21.2797 23.1196 20.6699 23.1373C17.7091 23.2215 14.8916 23.1535 11.9675 23.8576C11.376 24.0002 10.7773 23.6456 10.634 23.0667C10.4871 22.4882 10.8507 21.9025 11.4421 21.7603Z",
    fill: "#FE9CAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47642 15.457C10.1711 10.4234 16.2103 5.6808 22.3082 2.36592C22.8409 2.07684 23.5132 2.26513 23.807 2.78641C24.1009 3.30769 23.9099 3.96576 23.3772 4.25484C17.4813 7.46028 11.6405 12.047 7.10374 16.9142C6.69231 17.3542 5.99436 17.3848 5.54619 16.9826C5.09803 16.5805 5.06499 15.8969 5.47642 15.457Z",
    fill: "#FE9CAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.348196 14.1821C-0.426906 9.57841 0.895527 4.83325 2.76532 0.647172C3.01145 0.101052 3.66163 -0.148076 4.21633 0.0906042C4.77469 0.329644 5.02818 0.967214 4.78573 1.51333C3.08124 5.32573 1.81756 9.63745 2.52286 13.8304C2.62205 14.4186 2.2143 14.9748 1.61553 15.0716C1.01675 15.1688 0.44738 14.77 0.348196 14.1821Z",
    fill: "#FE9CAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawnAccents);
export default __webpack_public_path__ + "static/media/drawn-accents.0c5132d926b2c315cdb873487f4b74c1.svg";
export { ForwardRef as ReactComponent };